import { render, staticRenderFns } from "./IntegrationsItem.vue?vue&type=template&id=018bbfbf&scoped=true"
import script from "./IntegrationsItem.vue?vue&type=script&lang=js"
export * from "./IntegrationsItem.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsItem.vue?vue&type=style&index=0&id=018bbfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018bbfbf",
  null
  
)

export default component.exports